import { render, staticRenderFns } from "./SelectMultiArrows.vue?vue&type=template&id=30a7cbc0&"
import script from "./SelectMultiArrows.vue?vue&type=script&lang=js&"
export * from "./SelectMultiArrows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports